__turbopack_context__.v({
  "container": "CollapsibleArrayFieldTemplate-module__RVwGiG__container",
});
